import { useNavigate, Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth } from './AuthProvider';
import BaseApp from './base';
import PageLoader from 'components/PageLoader';
import logger from 'utils/logger';
import { IWG_GROUP } from './constants';

// Create a logger instance for this component
const log = logger.createLogger('ProtectedRoute');
// Protected Route Component
const ProtectedRoute = () => {
  const { isAuthenticated, currentUserInfo, userGroups, isLoading } = useAuth();
  const navigate = useNavigate();

  // For some reason on the first load, the user is not authenticated
  // So we need to check if the user is authenticated
  useEffect(() => {
    if (!isLoading) {
      if (!isAuthenticated) {
        const currentPath = window.location.pathname;
        if (currentPath !== '/login') {
          log.info('Not authenticated, redirecting to /login');
          navigate('/login');
        }
      } else {
        const currentPath = window.location.pathname;
        if (userGroups?.includes(IWG_GROUP)) {
          if (!currentPath.startsWith('/admin/dashboard')) {
            log.info('Authenticated, redirecting to /admin');
            navigate('/admin/dashboard/users');
          }
        } else {
          if (!currentPath.startsWith('/dashboard')) {
            log.info('Authenticated, redirecting to /dashboard');
            navigate('/dashboard/home');
          }
        }
      }
    }
  }, [isAuthenticated, isLoading, navigate, userGroups, currentUserInfo]);

  if (isLoading) {
    return <PageLoader />;
  }

  if (!isAuthenticated) {
    return null;
  }

  return (
    <BaseApp>
      <Outlet context={{ isAuthenticated, currentUserInfo }} />
    </BaseApp>
  );
};
export default ProtectedRoute;
